import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';
import { alibabaFlashVoices, alibabaVoices } from './voices/alibaba-voices';

// 系数
const COST_FACTOR = 2;

export const alibabaModels: Record<string, TersaSpeechModel> = {
    'qwen3-tts-flash': {
        default: true,
        promptLabel: 'Text',
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: wavespeed.speech('qwen3-tts-flash'),
                getCost: ({ characters }) => {
                    return (characters ?? 0) * 0.0002 * COST_FACTOR;
                },
            },
        ],
        voices: alibabaFlashVoices,
        voiceLabelPrefix: 'audio.voice.alibaba',
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen3-tts': {
        promptLabel: 'Text',
        lyricsLabel: 'Voice Style',
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: wavespeed.speech('qwen3-tts'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 100));
                    return units * 0.005 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics', ...alibabaVoices],
        voiceLabelPrefix: 'audio.voice.alibaba',
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'qwen3-voice-clone': {
        promptLabel: 'Text',
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: wavespeed.speech('qwen3-voice-clone'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 100));
                    return units * 0.005 * COST_FACTOR;
                },
            },
        ],
        voices: [],
        precheck: ['prompt'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
        inlineMedia: {
            allowInline: true,
            audio: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['audio/mpeg', 'audio/wav', 'audio/ogg'] },
            maxTotalCount: 1,
        },
    },
    'qwen3-voice-design': {
        promptLabel: 'Text',
        lyricsLabel: 'Voice Style',
        chef: providers.alibaba,
        providers: [
            {
                ...providers.alibaba,
                model: wavespeed.speech('qwen3-voice-design'),
                getCost: ({ characters }) => {
                    const units = Math.max(1, Math.ceil((characters ?? 0) / 100));
                    return units * 0.005 * COST_FACTOR;
                },
            },
        ],
        voices: ['lyrics'],
        precheck: ['prompt', 'lyrics'],
        supportsInput: ['t2a'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};